import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/integrations/all` layout. It no longer renders the shell — the migrated
 * page lives at `/integrations/all`, without the `journeys` segment. This is a pass-through: every
 * child hands off to the migrated URL (`JourneysIntegrationsHandoff`).
 *
 * The `/workspaces/last` resolver stays here, because these URLs are still reachable with the
 * sentinel from Ember-side links.
 */
function JourneysIntegrationsAllRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <Outlet />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/integrations/all')({
  component: JourneysIntegrationsAllRoute,
});
